import styled from 'styled-components';
import { Link } from 'react-router-dom';
import allbadeumImg from '@/assets/icon/allbadeum1161.png';
import kakaoImg from '@/assets/icon/icon-kakao.png';

const Success = () => {
  return (
    <Wrapper>
      <LeftBox>
        <Heading>선임권 신청</Heading>
        <Description>
          선임권 신청 페이지 안내 사항 내용 입니다. 접수해주신 사건의 내용, 지역 및 손해사정사의
          업무 처리 상황에 기반하여 올받음을 운영하는 어슈런스(주) 또는{' '}
          <strong>사건처리가 가능한</strong> 올받음 회원 손해사정사에게 입력한 정보가 전달되어
          연락을 드립니다. 또한 손해사정사 무료 선임권에 해당하지 않는 경우 문자로 안내를 드릴 수
          있습니다. 회원정보는 개인정보취급방침에 따라 안전하게 보호되며 위 내용 외 회원님의 동의
          없이는 공개 또는 제 3자에게 제공되지 않습니다.
        </Description>
      </LeftBox>

      <RightBox>
        <Title>접수 완료</Title>
        <ConfirmationBox>
          <span className="title">손해사정사 선임 신청</span>
          <span className="status">접수 완료</span>
          <Image src={allbadeumImg} alt="손해사정 선임 신청" />
        </ConfirmationBox>
        <InfoText>
          <DotIcon>!</DotIcon>
          <span>24시간 이내 손해사정사가 확인 후 연락드립니다.</span>
        </InfoText>
        <InfoText>
          <DotIcon>!</DotIcon>
          <span>손해사정사 선임권이 아닌 경우는 '올받음'에서 연락드립니다</span>
        </InfoText>
        <Note>
          ‘선임권 신청서’, ‘개인정보 제공 동의서’는 카카오톡을 통해 안전한 전자 문서로 제공됩니다.
        </Note>

        <BottomBox>
          <div>
            <Label>카카오톡 채널 추가하고 소식 받기</Label>
            <KakaoLink to="https://pf.kakao.com/_jSxgGxj">
              <img src={kakaoImg} alt="올받음 카카오톡 채널" />
              카카오톡 채널 추가
            </KakaoLink>
          </div>
          {/* <div>
            <Label>올받음 서비스 더보기</Label>
            <ServiceLink to="/qna">Q&A 바로가기</ServiceLink>
          </div> */}
        </BottomBox>
      </RightBox>
    </Wrapper>
  );
};

export default Success;

// ========================= styled-components =========================

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 24px 20px;
  max-width: 1040px;
  margin: 0 auto;

  @media (min-width: 1024px) {
    flex-direction: row;
    padding: 160px 20px;
  }
`;

const LeftBox = styled.div`
  padding: 24px 20px;
  max-width: 420px;

  @media (min-width: 1024px) {
    padding: 0;
  }
`;

const Heading = styled.h1`
  position: relative;
  width: fit-content;
  color: #111111;
  mix-blend-mode: multiply;

  font-family: 'Nexen_R', sans-serif;
  font-weight: 500; // Nexen_R_Medium 추정

  font-size: 20px;
  line-height: 28px;

  @media (min-width: 1024px) {
    font-size: 24px; // Nexen_R_Large 추정
    line-height: 32px;
  }

  &::after {
    content: '';
    position: absolute;
    bottom: 3px;
    z-index: -1;
    display: block;
    width: 100%;
    height: 6px;
    background-color: #d1dffb;

    @media (min-width: 1024px) {
      height: 12px;
    }
  }
`;

const Description = styled.p`
  margin-top: 12px;
  color: #757679;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.5;
  text-align: start;

  @media (min-width: 1024px) {
    margin-top: 16px;
  }
`;

const RightBox = styled.div`
  padding: 24px 20px;
  width: 100%;
  max-width: 512px;

  @media (min-width: 1024px) {
    padding: 0;
  }
`;

const Title = styled.h3`
  font-size: 20px;
  font-weight: 700;
  text-align: start;
`;

const ConfirmationBox = styled.div`
  margin-top: 16px;
  background: #f6f9fe;
  height: 160px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  padding: 38px 0 26px;

  span.title {
    color: #757679;
    font-size: 22px;
    font-weight: 500;
    z-index: 1;
  }

  span.status {
    color: #111;
    font-size: 32px;
    font-weight: 700;
    margin-top: 8px;
    z-index: 1;
  }

  @media (min-width: 1024px) {
    height: 210px;
    span.status {
      margin-top: 16px;
    }
  }
`;

const Image = styled.img`
  position: absolute;
  right: calc(50% + 30px);
  width: 84px;

  @media (min-width: 1024px) {
    left: 12px;
  }
`;

const InfoText = styled.div`
  display: flex;
  align-items: center;
  color: #4880ee;
  font-size: 14px;
  font-weight: 500;
  margin-top: 20px;

  @media (min-width: 1024px) {
    margin-top: 24px;
  }
`;

const DotIcon = styled.div`
  display: flex;
  width: 20px;
  height: 20px;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  border: 1px solid #4880ee;
  font-size: 14px;
  margin-right: 8px;
`;

const Note = styled.p`
  margin-top: 12px;
  color: #757679;
  font-size: 14px;
  font-weight: 400;
  text-align: start;

  @media (min-width: 1024px) {
    margin-top: 6px;
  }
`;

const BottomBox = styled.div`
  margin-top: 32px;
  display: flex;
  flex-direction: column;
  text-align: start;
  gap: 28px;

  @media (min-width: 1024px) {
    margin-top: 44px;
    flex-direction: row;
    justify-content: space-between;
  }
`;

const Label = styled.span`
  font-size: 14px;
  font-weight: 600;
  color: #111;
  text-align: start;
  margin-top: 28px;
`;

const KakaoLink = styled(Link)`
  margin-top: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fdd40c;
  height: 40px;
  width: 180px;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 500;
  color: #111;
  text-decoration: none;
  gap: 8px;

  @media (min-width: 1024px) {
    margin-top: 16px;
  }
`;

// const ServiceLink = styled(Link)`
//   margin-top: 16px;
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   height: 40px;
//   padding: 0 20px;
//   border: 1px solid #4880ee;
//   border-radius: 100px;
//   color: #4880ee;
//   font-size: 14px;
//   font-weight: 500;
//   text-decoration: none;
// `;
